// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file accounts/verify_email.proto (package protos.accounts, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file accounts/verify_email.proto.
 */
export const file_accounts_verify_email: GenFile = /*@__PURE__*/
  fileDesc("ChthY2NvdW50cy92ZXJpZnlfZW1haWwucHJvdG8SD3Byb3Rvcy5hY2NvdW50cyJpChJWZXJpZnlFbWFpbFJlcXVlc3QSOgoGcGFyYW1zGAEgASgLMioucHJvdG9zLmFjY291bnRzLlZlcmlmeUVtYWlsUmVxdWVzdC5QYXJhbXMaFwoGUGFyYW1zEg0KBWVtYWlsGAEgASgJIlwKE1ZlcmlmeUVtYWlsUmVzcG9uc2USOwoGcmVzdWx0GAEgASgLMisucHJvdG9zLmFjY291bnRzLlZlcmlmeUVtYWlsUmVzcG9uc2UuUmVzdWx0GggKBlJlc3VsdGIGcHJvdG8z");

/**
 * @generated from message protos.accounts.VerifyEmailRequest
 */
export type VerifyEmailRequest = Message<"protos.accounts.VerifyEmailRequest"> & {
  /**
   * @generated from field: protos.accounts.VerifyEmailRequest.Params params = 1;
   */
  params?: VerifyEmailRequest_Params | undefined;
};

/**
 * Describes the message protos.accounts.VerifyEmailRequest.
 * Use `create(VerifyEmailRequestSchema)` to create a new message.
 */
export const VerifyEmailRequestSchema: GenMessage<VerifyEmailRequest> = /*@__PURE__*/
  messageDesc(file_accounts_verify_email, 0);

/**
 * @generated from message protos.accounts.VerifyEmailRequest.Params
 */
export type VerifyEmailRequest_Params = Message<"protos.accounts.VerifyEmailRequest.Params"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * Describes the message protos.accounts.VerifyEmailRequest.Params.
 * Use `create(VerifyEmailRequest_ParamsSchema)` to create a new message.
 */
export const VerifyEmailRequest_ParamsSchema: GenMessage<VerifyEmailRequest_Params> = /*@__PURE__*/
  messageDesc(file_accounts_verify_email, 0, 0);

/**
 * @generated from message protos.accounts.VerifyEmailResponse
 */
export type VerifyEmailResponse = Message<"protos.accounts.VerifyEmailResponse"> & {
  /**
   * @generated from field: protos.accounts.VerifyEmailResponse.Result result = 1;
   */
  result?: VerifyEmailResponse_Result | undefined;
};

/**
 * Describes the message protos.accounts.VerifyEmailResponse.
 * Use `create(VerifyEmailResponseSchema)` to create a new message.
 */
export const VerifyEmailResponseSchema: GenMessage<VerifyEmailResponse> = /*@__PURE__*/
  messageDesc(file_accounts_verify_email, 1);

/**
 * @generated from message protos.accounts.VerifyEmailResponse.Result
 */
export type VerifyEmailResponse_Result = Message<"protos.accounts.VerifyEmailResponse.Result"> & {
};

/**
 * Describes the message protos.accounts.VerifyEmailResponse.Result.
 * Use `create(VerifyEmailResponse_ResultSchema)` to create a new message.
 */
export const VerifyEmailResponse_ResultSchema: GenMessage<VerifyEmailResponse_Result> = /*@__PURE__*/
  messageDesc(file_accounts_verify_email, 1, 0);

